module.exports = __webpack_public_path__ + "media/images/nl/upload-newsletter-5481488c5cca33696c13eb6a79ae6410.png";